import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { useMemo } from 'react';
import { useCalendarEvents } from '../../../../../../../../../../../../../hooks/calendarEvent';
import { IWeekdayActivitySchedule } from '../../../../../../../../../../../../../services/Activities/ListWeekdaysActivitySchedulesService';
import { ScheduleCard } from './components/ScheduleCard';
import { ScheduleTabs } from './components/ScheduleTabs';

const formatDay = (date: Date): string =>
  date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
  });

const formatWeekDay = (date: Date): string =>
  date.toLocaleDateString('pt-BR', {
    weekday: 'long',
  });

const formatTime = (date: Date): string =>
  date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });

type ScheduleBookingsModalProps = {
  eventId: string;
  isOpen: boolean;
  onClose: () => void;
  onCreateBooking: (schedule: IWeekdayActivitySchedule) => void;
  onCreateBookingQueue: (schedule: IWeekdayActivitySchedule) => void;
};

export default function ScheduleBookingsModal({
  eventId,
  isOpen,
  onClose,
  onCreateBooking,
  onCreateBookingQueue,
}: ScheduleBookingsModalProps): JSX.Element {
  const { calendarEvents } = useCalendarEvents();

  const selectedEvent = useMemo(
    () => calendarEvents.find((ev) => ev.id === eventId),
    [calendarEvents, eventId],
  );

  if (!selectedEvent) {
    onClose();

    return <></>;
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="7xl">
        <ModalOverlay />

        <ModalContent maxH="88vh">
          <ModalHeader>
            {`Dia ${formatDay(selectedEvent.start)} - ${formatWeekDay(
              selectedEvent.start,
            )} | ${formatTime(selectedEvent.start)} - ${formatTime(
              selectedEvent.end,
            )}`}
          </ModalHeader>

          <ModalCloseButton />

          <ModalBody overflow="auto">
            <ScheduleCard
              schedules={selectedEvent.schedules}
              onCreateBooking={onCreateBooking}
              onCreateBookingQueue={onCreateBookingQueue}
            />

            <ScheduleTabs event={selectedEvent} />
          </ModalBody>

          <ModalFooter />
        </ModalContent>
      </Modal>
    </>
  );
}
